import i18n from 'config/i18n';

export const getTranslation = (
  translationKey: string,
  translationParams?: Record<string, any>,
): string => i18n.t(translationKey, translationParams ?? undefined) as string;
